import React from "react";
import CustomRoutes from "../components/routes";

export default function MainRoutes() {
  return (
      <CustomRoutes />
  );
}
